import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: 'communityMember',
      method: 'get',
      request: (communityId, organisationId, t) => ({
        url: apiRoutes.communityMembersV2(communityId, organisationId),
        meta: {
          toaster: {
            onErrorMessage: t('getCommunityMembershipFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);
